export default class RuleParameterAlias {
  parameterId: string;

  alias: string;

  currentAlias: string;

  constructor(obj: any) {
    this.parameterId = obj.parameterId || '';
    this.alias = obj.alias || '';
    this.currentAlias = obj.alias || '';
  }

  static of(obj: any): RuleParameterAlias {
    return new RuleParameterAlias(obj || {});
  }

  static ofList(obj: any[]): RuleParameterAlias[] {
    return obj.map(this.of);
  }
}
